<div class="breadcrumbs-container">
    <div *ngFor="let step of steps; let i = index" class="breadcrumb-wrapper">
        <div class="circle-connector-container">
            <div class="circle" [class.completed]="i < currentStep" [class.active]="step.active" [class.non-active]="!step.active"
                (click)="step.active?onStepClick(i):null">
                {{ i + 1 }}
            </div>
            <div *ngIf="i < steps.length - 1" class="connector" [ngClass]="{'selected-connector':isConnectorActive(i+1)}"></div>
        </div>
        <div class="label"><strong>{{ step.label }}</strong></div>

        <!-- <div class="breadcrumb-label" >
            <div class="line1">{{ splitLabel(step.label)[0] }}</div>
            <div class="line2">{{ splitLabel(step.label)[1] }}</div>
          </div> -->
    </div>
</div>
 